import React, { Component } from 'react';
import { Redirect } from 'react-router';

export default class NotFoundScreen extends Component {
  render() {
    return <Redirect to="/dashboard" />;
  }
}
